import React from 'react';
import {ListContent, getListContentClass, processTranslation, processTranslationReplaceAll} from '../utils/commonUtil';
import {getGqlCompletePageContent} from './gqlCompletePageUtil';

const getListContent = (translations, userType, brandName, isSWSv2FlowEnabled, siteName, gqlEligibility) => {
    let contents;

    switch (userType) {
        case 'IPM_SOFTWARE_SWITCH':
            contents = [];
            contents.push(processTranslation(translations['ipmob.ppm.complete.dialog.list.content_1'], [brandName]));
            contents.push(processTranslationReplaceAll(translations['ipmob.ppm.complete.dialog.list.content_2'], [brandName]));
            contents.push(translations['ipmob.ppm.complete.dialog.list.content_3']);

            // if (isSWSv2FlowEnabled) {
            //     const removeDecommissionRelatedKeys = [processTranslationReplaceAll(translations['ipmob.ppm.complete.dialog.list.content_2'], [brandName]), translations['ipmob.ppm.complete.dialog.list.content_3']];
            //     contents = contents.filter(item => !removeDecommissionRelatedKeys.includes(item));
            // }
            break;
        case 'PPM':
            contents = [];
            contents.push(processTranslation(translations['ipmob.ppm.complete.dialog.list.content_1'], [brandName]));
            contents.push(processTranslationReplaceAll(translations['ipmob.ppm.complete.dialog.list.content_2'], [brandName]));
            contents.push(translations['ipmob.ppm.complete.dialog.list.content_3']);
            break;
        case 'IPM':
        default:
            contents = [];
            contents.push(translations['ipmob.complete.dialog.list.content.4']);
            contents.push(processTranslation(translations['ipmob.complete.dialog.list.content.1'], [brandName]));
            contents.push(translations['ipmob.complete.dialog.list.content.3']);
            break;
    }
    if (gqlEligibility) {
        contents.push("You are eligible for GQL service");
    }
    return contents;
};

const getCompletePageContent = (userType, translations, brandName, isSWSv2FlowEnabled, siteName, gqlEligibility) => {
    const contentList = getListContent(translations, userType, brandName, isSWSv2FlowEnabled, siteName, gqlEligibility);
    const listItemClass = getListContentClass(userType);

    return (
        <div className="complete-page-content">
            <ListContent
                contentList={contentList}
                listItemClass={listItemClass}
            />
        </div>
    );
};

const getCompletePageContentsForBMXFlow = (translations) => {
    return (
        <div className="complete-page-content">
                <p>
                    <strong>{translations['ipmob.complete.bmx.heading_1']}</strong>
                </p>
                <ul>
                    <li>
                        <p>
                            <span>
                                {translations['ipmob.complete.bmx.list_1']}
                            </span>
                        </p>
                    </li>
                    <li>
                        <p>
                            {translations['ipmob.complete.bmx.list_2']}
                        </p>
                    </li>
                </ul>
                <p>
                    <span>
                        <strong>{translations['ipmob.complete.bmx.heading_2']}</strong>
                    </span>
                </p>
                <p>
                    <span>
                        {translations['ipmob.complete.bmx.paragraph_1']}
                    </span>
                </p>
                <div style={{ height: '50px' }} />
            </div>
        );
    }

const getCompletePageContentsForPPMFlows = (translations, isGQL, isMOR) => {
    return (
        <div className="complete-page-content">
                <p> {isGQL ? translations['ipmob.complete.gql.inner_heading'] : translations['ipmob.complete.haxml.inner_heading']} </p>
                <p>
                    <strong>{isGQL ? translations['ipmob.complete.bmx.heading_1'] : translations['ipmob.complete.non_gql.heading_1']}</strong>
                </p>
            {isGQL ?
                <>
                    <ul>
                        <li>
                            {isMOR ?
                                <p>
                            <span>
                                {translations['ipmob.complete.bmx.list_1']}
                            </span>
                                </p> :
                                <>
                                    <p>
                                <span>
                                    {translations['ipmob.complete.non_mor.list_1']}
                                </span>
                                    </p>
                                    <ul>
                                        <li>
                                            <p>
                                                {translations['ipmob.complete.non_mor.sublist_1']}
                                            </p>
                                        </li>
                                        <li>
                                            <p>
                                                {translations['ipmob.complete.non_mor.sublist_2']}
                                            </p>
                                        </li>
                                    </ul>
                                </>}
                        </li>
                        <li>
                            <p>
                                {translations['ipmob.complete.common.content_1']}
                            </p>
                        </li>
                        <li>
                            <p>
                                {translations['ipmob.complete.gql.content_2']}
                            </p>
                        </li>
                        <li>
                            <p>
                                {translations['ipmob.complete.bmx.list_2']}
                            </p>
                        </li>
                    </ul>
                    <p>
                        <strong>{translations['ipmob.complete.bmx.heading_3']}</strong>
                    </p>
                    <p>
                        {translations['ipmob.complete.ppm.gql.content_1']}
                    </p>
                    <ul>
                        <li>
                            <p>
                                {translations['ipmob.complete.ppm.gql.content_2']}
                            </p>
                        </li>
                        <li>
                            <p>
                                {translations['ipmob.complete.ppm.gql.content_3']}
                            </p>
                        </li>
                        <li>
                            <p>
                                {translations['ipmob.complete.ppm.gql.content_4']}
                            </p>
                        </li>
                    </ul>
                </>
                : <>
                <ul>
                    <li>
                        <p>
                            {translations['ipmob.complete.ppm.non_gql.content_1']}
                        </p>
                    </li>
                    <li>
                        <p>
                            {translations['ipmob.complete.ppm.non_gql.content_2']}
                        </p>
                    </li>
                    <li>
                        <p>
                            {translations['ipmob.complete.ppm.non_gql.content_3']}
                        </p>
                    </li>
                    <li>
                        <p>
                            {translations['ipmob.complete.ppm.non_gql.content_4']}
                        </p>
                    </li>
                    <li>
                        <p>
                            {translations['ipmob.complete.bmx.list_2']}
                        </p>
                    </li>
                </ul>
                </>
            }
            {isMOR && (
                <>
                    <p>
                        <strong>{translations['ipmob.complete.bmx.heading_2']}</strong>
                    </p>
                    <p>
                        {translations['ipmob.complete.bmx.paragraph_1']}
                    </p>
                    <div style={{ height: '50px' }} />
                </>
            )}
        </div>
    );
}

const getCompletePageContentsForNetNewFlows = (translations, isGQL, isMOR) => {
    return (
        <div className="complete-page-content">
                <p> {isGQL ? translations['ipmob.complete.gql.inner_heading'] : translations['ipmob.complete.haxml.inner_heading']} </p>
                <p>
                    <strong>{isGQL ? translations['ipmob.complete.bmx.heading_1'] : translations['ipmob.complete.non_gql.heading_1']}</strong>
                </p>
                <ul>
                    <li>
                        {isMOR ?
                        <p>
                            <span>
                                {translations['ipmob.complete.bmx.list_1']}
                            </span>
                        </p> :
                        <>
                            <p>
                                <span>
                                    {translations['ipmob.complete.non_mor.list_1']}
                                </span>
                            </p>
                            <ul>
                                <li>
                                    <p>
                                        {translations['ipmob.complete.non_mor.sublist_1']}
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        {translations['ipmob.complete.non_mor.sublist_2']}
                                    </p>
                                </li>
                            </ul>
                        </>}
                    </li>
                    {isGQL ?
                    <li>
                        <p>
                            {translations['ipmob.complete.gql.content_1']}
                        </p>
                    </li> :
                    <>
                        <li>
                            <p>
                                {translations['ipmob.complete.non_gql.content_1']}
                            </p>
                        </li>
                        <li>
                            <p>
                                {translations['ipmob.complete.non_gql.content_2']}
                            </p>
                        </li>
                    </>
                    }
                    <li>
                        <p>
                            {translations['ipmob.complete.common.content_1']}
                        </p>
                    </li>
                    <li>
                        <p>
                            {translations['ipmob.complete.bmx.list_2']}
                        </p>
                    </li>
                </ul>
                {isMOR ?
                <>
                <div className="illustration-divider"/>
                <p>
                    <span>
                        <strong>{translations['ipmob.complete.bmx.heading_2']}</strong>
                    </span>
                </p>
                <p>
                    <span>
                        {translations['ipmob.complete.bmx.paragraph_1']}
                    </span>
                </p>
                <div style={{ height: '50px' }} />
                </> : null}
            </div>
        );
    }


const getCompletePageContentsForSSXFlows = (translations, isGQL, isMOR) => {
    return (
        <div className="complete-page-content">
                <p> {isGQL ? translations['ipmob.complete.gql.inner_heading'] : translations['ipmob.complete.haxml.inner_heading']} </p>
                <p>
                    <strong>{isGQL ? translations['ipmob.complete.bmx.heading_1'] : translations['ipmob.complete.non_gql.heading_1']}</strong>
                </p>
            {isGQL ?
                <>
                    <ul>
                        <li>
                            {isMOR ?
                                <p>
                                    <span>{translations['ipmob.complete.bmx.list_1']}</span>
                                </p>
                                :
                                <>
                                    <p>
                                        <span>{translations['ipmob.complete.non_mor.list_1']}</span>
                                    </p>
                                    <ul>
                                        <li>
                                            <p>{translations['ipmob.complete.non_mor.sublist_1']}</p>
                                        </li>
                                        <li>
                                            <p>{translations['ipmob.complete.non_mor.sublist_2']}</p>
                                        </li>
                                    </ul>
                                </>
                            }
                        </li>
                        <li>
                            <p>{translations['ipmob.complete.common.content_1']}</p>
                        </li>
                        <li>
                            <p>{translations['ipmob.complete.gql.content_2']}</p>
                        </li>
                        <li>
                            <p>{translations['ipmob.complete.gql.content_3']}</p>
                        </li>
                        <li>
                            <p>{translations['ipmob.complete.bmx.list_2']}</p>
                        </li>
                    </ul>
                </>
                :
                <>
                    <ul>
                        <li>
                            <p>{translations['ipmob.complete.ssx.non_gql.list_1']}</p>
                        </li>
                        <li>
                            <p>{translations['ipmob.complete.ssx.non_gql.list_2']}</p>
                        </li>
                        <li>
                            <p>{translations['ipmob.complete.ssx.non_gql.list_3']}</p>
                        </li>
                    </ul>
                </>
            }
            {isMOR && (
                <>
                    <p>
                        <strong>{translations['ipmob.complete.bmx.heading_2']}</strong>
                    </p>
                    <p>
                        {translations['ipmob.complete.bmx.paragraph_1']}
                    </p>
                    <div style={{ height: '50px' }} />
                </>
            )}
        </div>
    );
}

const FINANCIAL_PROFILE_PATH = '/supply/financial-profile-management';

const getFinancialProfileUrl = (environment) => {
    if (environment === 'production') {
        return `https://vrbo.com${FINANCIAL_PROFILE_PATH}`;
    }
    return `https://stage.vrbo.com${FINANCIAL_PROFILE_PATH}`;
};

const redirectToFinancialProfile = (environment) => {
    window.location.href = getFinancialProfileUrl(environment);
};


const getCompletePageContents = (gqlUserType, translations, brandName, isSWSv2FlowEnabled, siteName, gqlStatus, userType, businessModel, ipmBankingEnabled, systemId, environment) => {
    let completePageContents = {};

    if (ipmBankingEnabled) {
        if (userType === 'BUSINESS_MODEL_SWITCH') {
            return {
                heading: translations['ipmob.complete.bmx.main_heading'],
                dialogHeading: "",
                contents: getCompletePageContentsForBMXFlow(translations),
                dialogFooter: "",
                actionLabel: translations['ipmob.complete.bmx.button.label']
            };
        }

        if (businessModel === 'EG') {
            if (gqlStatus) {
                // Get GQL MoR content based on userType (IPM, PPM, IPM_SOFTWARE_SWITCH)
                switch (gqlUserType) {
                    case 'IPM':
                        completePageContents.heading = translations['ipmob.complete.netnew.main_heading'];
                        completePageContents.dialogHeading = "";
                        completePageContents.contents = getCompletePageContentsForNetNewFlows(translations, true, true);
                        completePageContents.dialogFooter = "";
                        completePageContents.actionLabel = translations['ipmob.complete.bmx.button.label'];
                        completePageContents.handleSubmit = () => redirectToFinancialProfile(environment);
                        break;
                    case 'PPM':
                        completePageContents.heading = translations['ipmob.complete.ppm.gql.main_heading'];
                        completePageContents.dialogHeading = "";
                        completePageContents.contents = getCompletePageContentsForPPMFlows(translations, true, true);
                        completePageContents.dialogFooter = "";
                        completePageContents.actionLabel = translations['ipmob.complete.bmx.button.label'];
                        completePageContents.handleSubmit = () => redirectToFinancialProfile(environment);
                        break;
                    default:
                        completePageContents.heading = processTranslation(translations['ipmob.complete.ssx.gql.main_heading'], [systemId]);
                        completePageContents.dialogHeading = "";
                        completePageContents.contents = getCompletePageContentsForSSXFlows(translations, true, true);
                        completePageContents.dialogFooter = "";
                        completePageContents.actionLabel = translations['ipmob.complete.bmx.button.label'];
                        completePageContents.handleSubmit = () => redirectToFinancialProfile(environment);
                        break;
                }
            } else {
                // Get HAXML MoR content based on userType (IPM, PPM, IPM_SOFTWARE_SWITCH)
                switch (gqlUserType) {
                    case 'IPM':
                        completePageContents.heading = translations['ipmob.complete.netnew.main_heading'];
                        completePageContents.dialogHeading = "";
                        completePageContents.contents = getCompletePageContentsForNetNewFlows(translations, false, true);
                        completePageContents.dialogFooter = "";
                        completePageContents.actionLabel = translations['ipmob.complete.bmx.button.label'];
                        completePageContents.handleSubmit = () => redirectToFinancialProfile(environment);
                        break;
                    case 'PPM':
                        completePageContents.heading = translations['ipmob.complete.ppm.non_gql.main_heading'];
                        completePageContents.dialogHeading = "";
                        completePageContents.contents = getCompletePageContentsForPPMFlows(translations, false, true);
                        completePageContents.dialogFooter = "";
                        completePageContents.actionLabel = translations['ipmob.complete.bmx.button.label'];
                        completePageContents.handleSubmit = () => redirectToFinancialProfile(environment);
                        break;
                    default:
                        completePageContents.heading = translations['ipmob.complete.ssx.non_gql.main_heading'];
                        completePageContents.dialogHeading = "";
                        completePageContents.contents = getCompletePageContentsForSSXFlows(translations, false, true);
                        completePageContents.dialogFooter = "";
                        completePageContents.actionLabel = translations['ipmob.complete.bmx.button.label'];
                        completePageContents.handleSubmit = () => redirectToFinancialProfile(environment);
                        break;
                }
            }
            return completePageContents;
        }
            if (gqlStatus) {
                // Get GQL Agency content based on userType (IPM, PPM, IPM_SOFTWARE_SWITCH)
                switch (gqlUserType) {
                    case 'IPM':
                        completePageContents.heading = translations['ipmob.complete.netnew.main_heading'];
                        completePageContents.dialogHeading = "";
                        completePageContents.contents = getCompletePageContentsForNetNewFlows(translations, true, false);
                        completePageContents.dialogFooter = "";
                        completePageContents.actionLabel = null;
                        break;
                    case 'PPM':
                        completePageContents.heading = translations['ipmob.complete.ppm.gql.main_heading'];
                        completePageContents.dialogHeading = "";
                        completePageContents.contents = getCompletePageContentsForPPMFlows(translations, true, false);
                        completePageContents.dialogFooter = "";
                        completePageContents.actionLabel = null;
                        break;
                    default:
                        completePageContents.heading = processTranslation(translations['ipmob.complete.ssx.gql.main_heading'], [systemId]);
                        completePageContents.dialogHeading = "";
                        completePageContents.contents = getCompletePageContentsForSSXFlows(translations, true, false);
                        completePageContents.dialogFooter = "";
                        completePageContents.actionLabel = null;
                        break;
                }
            } else {
                // Get HAXML Agency content based on userType (IPM, PPM, IPM_SOFTWARE_SWITCH)
                switch (gqlUserType) {
                    case 'IPM':
                        completePageContents.heading = translations['ipmob.complete.netnew.main_heading'];
                        completePageContents.dialogHeading = "";
                        completePageContents.contents = getCompletePageContentsForNetNewFlows(translations, false, false);
                        completePageContents.dialogFooter = "";
                        completePageContents.actionLabel = null;
                        break;
                    case 'PPM':
                        completePageContents.heading = translations['ipmob.complete.ppm.non_gql.main_heading'];
                        completePageContents.dialogHeading = "";
                        completePageContents.contents = getCompletePageContentsForPPMFlows(translations, false, false);
                        completePageContents.dialogFooter = "";
                        completePageContents.actionLabel = null;
                        break;
                    default:
                        completePageContents.heading = translations['ipmob.complete.ssx.non_gql.main_heading'];
                        completePageContents.dialogHeading = "";
                        completePageContents.contents = getCompletePageContentsForSSXFlows(translations, false, false);
                        completePageContents.dialogFooter = "";
                        completePageContents.actionLabel = null;
                        break;
                }
            }

            return completePageContents;

    }

        if (gqlStatus) {
            return getGqlCompletePageContent(gqlUserType, translations);
        }
        return {
            heading: translations['ipmob.complete.heading'],
            dialogHeading: translations['ipmob.complete.dialog.heading'],
            contents: getCompletePageContent(gqlUserType, translations, brandName, isSWSv2FlowEnabled, siteName, false),
            dialogFooter: translations['ipmob.complete.dialog.footer']
        };

};

export {getCompletePageContents};
